import {MaybePromise} from '@coolcolduk/typescript-util';

/**
 * Run function and catch error.
 * @param fn
 * @returns undefined when successful, or the error message string when an error was thrown
 */
export default async function messageWhenThrown(fn: () => MaybePromise<unknown>): Promise<string | undefined> {
  try {
    await fn();
    return undefined;
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : String(e);
    return message;
  }
}
